import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { selectMyTicketsByType } from '@/redux/selectors/lotterySelector';
import { useAppSelector } from '@/redux/store';

import { useCurrentLotteryTier, useWinnerTicketSteps } from '../../hooks';

interface CountOfMatchesProps {
  className?: string;
}

const CountOfMatches: FC<CountOfMatchesProps> = ({ className }) => {
  const { t } = useTranslation();
  const currentTier = useCurrentLotteryTier();
  const myTickets = useAppSelector((state) =>
    selectMyTicketsByType(state, currentTier),
  );
  const { filteredValue } = useWinnerTicketSteps();

  const count =
    myTickets && filteredValue
      ? myTickets.filter(({ ticket }) => ticket.startsWith(filteredValue))
          .length
      : myTickets?.length || 0;

  return (
    <div className={cn('flex flex-col items-center w-[56px]', className)}>
      <span className="text-[24px] font-extrabold leading-none">{count}</span>
      <span className="text-white/60 text-[10px] leading-none">
        {t('Coincidences')}
      </span>
    </div>
  );
};

export { CountOfMatches };
